(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class CustomStickyHeader extends HTMLElement {
constructor() { super(); }

connectedCallback() {
this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
this.onScrollHandler = this.onScroll.bind(this);
window.addEventListener('scroll', this.onScrollHandler, { passive: true });

// Ensure nested dropdown details elements remain expanded automatically
const innerDetails = this.querySelectorAll('.header__submenu details, .mega-menu__list details, .list-menu--disclosure details');
innerDetails.forEach(detail => {
detail.setAttribute('open', 'true');
detail.addEventListener('toggle', function() {
if (!this.open) {
this.open = true;
}
});
});
}

disconnectedCallback() {
window.removeEventListener('scroll', this.onScrollHandler);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (scrollTop > 50) {
this.classList.add('is-scrolled');
} else {
this.classList.remove('is-scrolled');
}

/* Hides on scroll down, reveals on scroll up */
if (scrollTop > this.currentScrollTop && scrollTop > 50) {
this.classList.add('is-hidden');
}
else if (scrollTop < this.currentScrollTop) {
this.classList.remove('is-hidden');
}

this.currentScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}
}

/* Define custom element strictly to bypass Shopify defaults */
if (!customElements.get('custom-sticky-header')) {
customElements.define('custom-sticky-header', CustomStickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
